import APIClient from '@/shared/http/clients/api'

const resourceName = 'RiscosEspeciais'
const APIBusinessCommon = process.env.APIBaseURLBusinessCommon

const GetRiscoEspecial = (apr, revisao, data = {}, config = {}) => APIClient.get(`${APIBusinessCommon}/${resourceName}/GetRiscoEspecial/${apr}/${revisao}`, data, config)

const SpecialRisksRepository = {
  GetRiscoEspecial
}

export default SpecialRisksRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/business/SpecialRisks.js